import React, { Component } from "react";
import { createPortal } from "react-dom";
import { Checkbox, Popover, Radio } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import Panel from "../../../components/Panel";
import SPICEFileSelect from "./components/SPICEFileSelect";
import {
  drawTxModelHelper,
  drawTxModelIBISDiagramHelper,
  getDrawer,
} from "../../../services/Andes_v2/simulation/canvasDrawer";
import { BUFFER_SPICE, IBIS, SPICE } from "../../../constants/libraryConstants";
import SubcktNodeSelect from "./components/SubcktNodeSelect";
import {
  handleSelectSubckt,
  getNodeSelectOption,
  getSubcktByPairInfo,
  handleSelectFile,
  getFileTreeData,
  getIBISModelSelectList,
  splitTxModelType,
  initTxModelPinModels,
  getTxModelIBISCanvasPosition,
  getNextNodeVisible,
} from "../../../services/Andes_v2/simulation";
import IBISRender from "./components/IBISRender";
import libraryConstructor from "../../../services/Andes_v2/library/libraryConstructor";
import ClickOutsideManager from "../Manager/ClickOutsideManager";

/**
 * TxModel: Only the selection of one spice model file is supported
 */
class TxModel extends Component {
  constructor() {
    super();
    this.state = {
      applyAll: false,
      fileTreeData: [],
      subckt: {},
      nodeVisible: "",
      model: {
        type: SPICE,
        files: [],
        pairs: [],
      },
      ibisLibraryList: libraryConstructor.getLibraryValues(IBIS) || [],
      modelNameSelectList: [],
      modelTypeSelectList: [],
      selectorModels: []
    };
    this.dialogRoot = document.getElementById("root");
  }
  async componentDidMount() {
    const { model } = this.props;
    const { drawer, canvas } = getDrawer(
      "andes-v2-hspice-simulation-tx-model-canvas",
      null,
      { left: 1.5, top: 1.5 }
    );

    this.drawer = drawer;
    this.canvas = canvas;

    let modelNameSelectList = [], modelTypeSelectList = [], selectorModels = [];
    const { files, type } = model;
    let fileTreeData = []
    if (/ibis/.test(type)) {
      const file = files[0] || {};
      const selectListInfo = await getIBISModelSelectList(file, "Tx");
      modelNameSelectList = selectListInfo.modelNameSelectList;
      modelTypeSelectList = selectListInfo.modelTypeSelectList;
      selectorModels = selectListInfo.selectorModels;
    } else {
      drawTxModelHelper({ drawer });
      fileTreeData = await getFileTreeData([SPICE, BUFFER_SPICE], model.files)
    }
    this.unsubscribe = ClickOutsideManager.subscribe(this.handleClickOutside);
    this.setState({
      model: JSON.parse(JSON.stringify(model)),
      fileTreeData,
      modelNameSelectList,
      modelTypeSelectList,
      selectorModels
    }, () => {
      /ibis/.test(type) && this.IBISRenderRef && this.IBISRenderRef.getIBISPinAndModelColumns();
      this.isMountedFlag = true;
    });
  }

  componentWillUnmount() {
    this.isMountedFlag = false;
    this.unsubscribe();
  }

  async componentDidUpdate(prevProps) {
    const { libraryStatus, model } = this.props;
    if (prevProps.libraryStatus !== libraryStatus) {
      this.setState({
        fileTreeData: await getFileTreeData([SPICE, BUFFER_SPICE], model.files),
        ibisLibraryList: libraryConstructor.getLibraryValues(IBIS)
      });
    }
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const { nodeVisible } = this.state;
    const PopoverRoot = document.getElementById(nodeVisible);

    if (!PopoverRoot) {
      return;
    }

    if (!PopoverRoot || !PopoverRoot.contains(target)) {
      this.setState({ nodeVisible: "" });
    }
  };

  closeModal = () => {
    const { model, applyAll } = this.state;
    if (this.isMountedFlag) {
      this.props.closeModal(model, applyAll);
    }
  };

  selectModelFile = (file, fileIndex) => {
    const { model } = this.state;
    const { files, pairs } = handleSelectFile(
      "txModel",
      model,
      file,
      fileIndex
    );
    this.setState({ model: { ...model, files, pairs }, subckt: {} });
  };

  selectSubckt = (subckt, modelKey, file) => {
    const { model } = this.state;
    const { files, pairs } = handleSelectSubckt(
      "txModel",
      model,
      subckt,
      modelKey,
      file
    );
    this.setState({ model: { ...model, files, pairs }, subckt });
  };

  selectNode = (node, pairIndex) => {
    const { model } = this.state;
    const _pairs = [...model.pairs],
      file = model.files[0];
    _pairs[pairIndex].node = node;
    _pairs[pairIndex].fileName = file.fileName;
    _pairs[pairIndex].libraryId = file.libraryId;
    _pairs[pairIndex].subckt = file.subckt;

    let nodeVisible = "";
    if (node) {
      const { _nodeVisible, _nextPairIndex } = getNextNodeVisible(_pairs, pairIndex, "tx-model-subckt-node-popover");
      nodeVisible = _nodeVisible;
      if (_nextPairIndex !== -1) {
        this.setNodeVisible(
          nodeVisible,
          _pairs[_nextPairIndex],
          true
        )
      }
    }

    this.setState({ model: { ...model, pairs: _pairs }, nodeVisible });
  };

  applyChange = (e) => {
    this.setState({ applyAll: e.target.checked });
  };

  clearNodeVisible = () => {
    this.setState({ nodeVisible: "" });
  };

  setNodeVisible = async (visible, pair, isReturnVisible) => {
    const {
      subckt,
      model: { files = [] },
    } = this.state;
    const fileInfo = pair.node ? pair : files[0];
    if (visible && !Object.keys(subckt).length && fileInfo) {
      const subcktInfo = await getSubcktByPairInfo(fileInfo);
      this.setState({ subckt: subcktInfo });
    }
    if (isReturnVisible) {
      return visible;
    }
    this.setState({ nodeVisible: visible });
  };

  updateFileTreeData = (children) => {
    const { fileTreeData } = this.state;
    this.setState({ fileTreeData: fileTreeData.concat(children) })
  }

  IBISRender = () => {
    const { ibisLibraryList, modelTypeSelectList, modelNameSelectList, selectorModels, model } = this.state;
    return <IBISRender
      ibisLibraryList={ibisLibraryList}
      modelTypeSelectList={modelTypeSelectList}
      selectorModels={selectorModels}
      modelNameSelectList={modelNameSelectList}
      model={model}
      setModelInfo={(params) => this.setState({ ...params })}
      ref={(ref) => this.IBISRenderRef = ref}
      type="Tx"
    />
  }

  SPICERender = () => {
    const {
      subckt,
      nodeVisible,
      model: { files = [], pairs = [] },
      fileTreeData
    } = this.state;
    const { signalName } = this.props;
    const nodeList = getNodeSelectOption("txModel", pairs, subckt);
    return <>
      {files.length !== 0 ? (
        files.map((file, index) => (<div key={`${file.libraryId}-${index}` || `rx-model-${index}`}>
          <SPICEFileSelect
            fileTreeData={fileTreeData}
            selectModelFile={(file) => this.selectModelFile(file, index)}
            selectSubckt={(subckt) => this.selectSubckt(subckt, file.modelKey, file)}
            updateFileTreeData={this.updateFileTreeData}
            file={file}
          />
        </div>
        ))) : <SPICEFileSelect
        fileTreeData={fileTreeData}
        selectModelFile={(file) => this.selectModelFile(file, -1)}
        selectSubckt={(subckt) => this.selectSubckt(subckt, -1)}
        updateFileTreeData={this.updateFileTreeData}
        file={{}}
      />}
      {/* modal - node */}
      <div className="andes-v2-hspice-simulation-tx-model-canvas-box">
        {/* Node select */}
        {pairs.map((item, index) => (
          <div
            key={`tx-model-${item.pin}`}
            className="andes-v2-hspice-simulation-tx-model-node"
          >
            <SubcktNodeSelect
              nodeList={nodeList}
              displayPin={item.pin}
              nodeValue={item.node}
              selectNode={(node) => this.selectNode(node, index)}
              visible={nodeVisible === `tx-model-subckt-node-popover-${item.pin}`}
              clickNode={() => this.setNodeVisible(`tx-model-subckt-node-popover-${item.pin}`, item)}
              closeNodelSelect={() => this.clearNodeVisible()}
              id={`tx-model-subckt-node-popover-${item.pin}`}
            />
          </div>
        ))}
        {/* Net text */}
        {pairs.map((item) => (
          <span key={`tx-model-${item.net}`}>{item.net}</span>
        ))}
        {/* Signal */}
        <span className="andes-v2-hspice-simulation-tx-model-signal-name andes-v2-hspice-no-wrap">{signalName}</span>
        <canvas id="andes-v2-hspice-simulation-tx-model-canvas" width="600" height="200"></canvas>
      </div>
    </>
  }

  changeModelType = async (value) => {
    const { model, fileTreeData } = this.state;
    let _pinModels = [...model.pinModels], type = model.type, _pairs = [...model.pairs], _fileTreeData = [];

    // switch type post-processing, clear files, clear pinModels data about file selection
    if (/ibis/.test(type)) {
      _pinModels = _pinModels.map(item => {
        return { ...item, libraryId: "", fileName: "", modelName: "", modelType: "" }
      })
      if (!fileTreeData.length) {
        _fileTreeData = await getFileTreeData([SPICE, BUFFER_SPICE], [])
      }
    } else {
      _pairs = _pairs.map(item => {
        return { node: "", pin: item.pin, net: item.net }
      })
    }

    this.setState({
      model: {
        type: value === IBIS ? 'duo-ibis' : value,
        files: [],
        pinModels: [..._pinModels],
        pairs: [..._pairs]
      },
      fileTreeData: [..._fileTreeData]
    }, () => {
      if (value === IBIS) {
        this.IBISRenderRef && this.IBISRenderRef.getIBISPinAndModelColumns();
      } else {
        const { drawer, canvas } = getDrawer(
          "andes-v2-hspice-simulation-tx-model-canvas",
          null,
          { left: 1.5, top: 1.5 }
        );

        this.drawer = drawer;
        this.canvas = canvas;
        drawTxModelHelper({ drawer: this.drawer });
      }

      this.props.changeCanvasEle('stimulus', value === IBIS)
    })
  }

  changeIBISBundle = (value) => {
    const { signal } = this.props;
    const { model } = this.state;
    const { pinModels = [], pairs } = model;
    let _pinModels = [...pinModels];
    // Filter or generate pin suffixes as A2/B2/C2
    if (value === "duo-ibis") { // filter
      _pinModels = _pinModels.filter(item => {
        return !(/_[A-C]2$/.test(item.pin))
      })
    } else { // add
      _pinModels = initTxModelPinModels(pairs, signal, _pinModels, true);
    }
    this.setState({ model: { ...model, type: value, pinModels: [..._pinModels] } })
  }


  drawCanvas(pinNumber, type) {
    const { drawer } = getDrawer(`andes-v2-tx-model-ibis-diagram-${type}`, undefined, { left: 10, top: 20 });
    drawTxModelIBISDiagramHelper({ drawer, pinNumber })
  }

  ibisCanvasRender = (pinNumber, type, pairs) => {
    const { signal } = this.props;
    const canvasDataList = getTxModelIBISCanvasPosition(pinNumber, signal, pairs);
    return <div className="andes-v2-tx-model-ibis-diagram">
      {canvasDataList.map(({ top, left, key, suffix, pinName }) => {
        return <div key={key} style={{ top, left }}>
          {
            suffix ? <div className="pin-name">
              <div>{pinName}</div>
              <div>{suffix}</div>
            </div> : key
          }
        </div>
      })}
      <canvas id={`andes-v2-tx-model-ibis-diagram-${type}`} width="520" height={pinNumber === 3 ? "300" : "240"}></canvas>
    </div>
  }

  render() {
    const { applyAll, model: { type, pairs } } = this.state;
    const { modelType } = splitTxModelType(type);
    const content = (
      <Panel
        className="andes-v2-model-panel"
        position="panel-center-left"
        title="Tx Buffer"
        zIndex={2000}
        onCancel={() => this.closeModal()}
        width={600}
        draggable
        minHeight={200}
      >
        <div className="andes-v2-hspice-simulation-model-content">
          {/* Model Type */}
          <div className='andes-v2-hspice-simulation-flex'>
            <span className='andes-v2-hspice-simulation-title'>Model Type</span>
            <Radio.Group onChange={(e) => this.changeModelType(e.target.value)} value={modelType}>
              <Radio value={IBIS}>IBIS</Radio>
              <Radio value={SPICE}>SPICE</Radio>
            </Radio.Group>
          </div>
          {/ibis/.test(type) ? <>
            {/* Model Bundle */}
            <div className='andes-v2-hspice-simulation-flex'>
              <span className='andes-v2-hspice-simulation-title'>IBIS Bundle</span>
              <Radio.Group onChange={(e) => this.changeIBISBundle(e.target.value)} value={type}>
                {
                  [{ value: "duo-ibis", label: "Two IBIS buffers per wire", pinNumber: 2 },
                  { value: "trio-ibis", label: "Three IBIS buffers per wire", pinNumber: 3, disabled: true }]
                    .map(({ value, label, pinNumber, disabled }) => {
                      return <Radio value={value} key={value} disabled={disabled}>
                        {label}
                        <Popover
                          placement="top"
                          content={this.ibisCanvasRender(pinNumber, value, pairs)}
                          onOpenChange={(open) => {
                            if (open) {
                              this.drawCanvas(pinNumber, value);
                            }
                          }}
                          destroyOnHidden={true}
                          classNames={{ root: "andes-v2-tx-model-ibis-diagram-popover" }}
                        >
                          <QuestionCircleOutlined className='andes-v2-hspice-help-icon' />
                        </Popover>
                      </Radio>
                    })
                }
              </Radio.Group>
            </div>
            {this.IBISRender()}
          </>
            : this.SPICERender()}
          {/* modal - apply all */}
          {<div className="ads-model-apply-all-content">
            <span>Apply setting to all signal</span>
            <Checkbox
              checked={applyAll}
              onChange={(e) => this.applyChange(e)}
            />
          </div>}
        </div>
      </Panel>
    );
    return createPortal(content, this.dialogRoot);
  }
}

export default TxModel;
